import { ChangeDetectionStrategy, ChangeDetectorRef, Component, inject } from '@angular/core';

import { Camera } from '@capacitor/camera';
import { Capacitor } from '@capacitor/core';
import { Geolocation } from '@capacitor/geolocation';
import { PushNotifications } from '@capacitor/push-notifications';
import { Platform } from '@ionic/angular';

import { AndroidSettings, IOSSettings, NativeSettings } from 'capacitor-native-settings';
import { Subscription } from 'rxjs';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'red-permissions',
  standalone: false,
  templateUrl: './permissions.page.html'
})
export class PermissionsPageComponent {
  private changeDetectorRef = inject(ChangeDetectorRef);
  private platform = inject(Platform);

  isWebBrowser = !Capacitor.isNativePlatform();
  pushNotificationsPermission = false;
  locationPermission = false;
  cameraPermission = false;

  platformResumeSubscription: Subscription | null = null;

  async ionViewDidEnter() {
    await this.checkPermissions();
    this.platformResumeSubscription = this.platform.resume.subscribe(() => {
      this.checkPermissions();
    });
  }

  ionViewWillLeave() {
    if (this.platformResumeSubscription) {
      this.platformResumeSubscription.unsubscribe();
    }
  }

  async checkPermissions() {
    if (!this.isWebBrowser) {
      const { receive } = await PushNotifications.checkPermissions();
      this.pushNotificationsPermission = receive === 'granted';

      const { camera } = await Camera.checkPermissions();
      this.cameraPermission = camera === 'granted';
    }

    const { location } = await Geolocation.checkPermissions();
    this.locationPermission = location === 'granted';
    this.changeDetectorRef.detectChanges();
  }

  async openNativeSettings(event: MouseEvent, optionAndroid: AndroidSettings = AndroidSettings.ApplicationDetails) {
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    if (!this.isWebBrowser) {
      await NativeSettings.open({
        optionAndroid,
        optionIOS: IOSSettings.App
      });
    }
    return false;
  }

  protected readonly androidSettings = AndroidSettings;
}
